import type { ReactElement, ReactNode } from 'react';
import { UI_DEFAULTS } from '@gr/core/platform/config/ui-config';
import type { EntityDto, EntityTypeDto, ReferenceTitleDto } from '@gr/core/content/entities/dto';
import { Link } from '../../../../app/di';
import { DataTable } from '../../../../ui-kit/DataTable/DataTable';
import { FieldValueView } from '../FieldValueView/FieldValueView';

export interface EntityTableProps {
  blogId: string;
  type: EntityTypeDto;
  entities: readonly EntityDto[];
  titles: Readonly<Record<string, ReferenceTitleDto>>;
  empty: ReactNode;
  /** Колонок с полями — не больше (ui.entities.table): на телефоне это карточки. */
  maxFieldColumns?: number;
}

/** ENT-UC-6: записи справочника — заголовок и первые поля. */
export function EntityTable({ blogId, type, entities, titles, empty, maxFieldColumns = UI_DEFAULTS.entities.table.maxFieldColumns }: EntityTableProps): ReactElement {
  const titleLabel = type.fields.find((f) => f.key === type.titleFieldKey)?.label ?? '';
  const columns = type.fields.filter((field) => field.key !== type.titleFieldKey).slice(0, maxFieldColumns);
  return (
    <DataTable
      label={type.pluralName}
      rows={entities}
      rowKey={(entity) => entity.id}
      empty={empty}
      columns={[
        {
          key: 'title',
          header: titleLabel,
          primary: true,
          cell: (entity) => (
            <Link to="entity" params={{ blogId, typeId: type.id, entityId: entity.id }}>
              <strong>{entity.title}</strong>
            </Link>
          ),
        },
        ...columns.map((field) => ({
          key: field.key,
          header: field.label,
          cell: (entity: EntityDto) => <FieldValueView blogId={blogId} field={field} value={entity.values[field.key]} titles={titles} />,
        })),
      ]}
    />
  );
}
